<template>
<div class="content">
    <!-- Header Section -->
    <header class="header-section">
        <h1>Customer Trustworthiness Database</h1>
        <p>Sharing information about customers with credibility and trustworthiness issues.</p>
        <img src="../../assets/img/pic2.jpg" alt="Header Image" class="header-img">
    </header>
    <div class="container-fluid">
        <!-- How We Work Section -->
        <section class="how-we-work-section mt-5 text-center">
            <h2>How We Work</h2>
            <p>We gather and share data about customers who have issues with credibility and trustworthiness. Our goal is to provide transparency and help businesses make informed decisions.</p>
            <img src="../../assets/img/pic1.jpg" alt="How We Work" class="section-img">
        </section>

        <!-- Customer List Section -->
        <section class="customer-list-section mt-5">
            <div class="row">
                <div class="col-12">
                    <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
                        <template slot="header" v-if="!publicLogin">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h3 class="card-title">Customers with Credibility Issues</h3>
                                </div>
                            </div>
                            <div>
                                <p>Kindly login to view the user list</p>
                                <button class="btn btn-fill btn-primary mb-3" @click="gotoLogin">Login</button>
                            </div>
                        </template>
                        <template v-if="publicLogin && usersList.length === 0">
                            <div class="card-body">
                                <div class="col-md-12">No data available.</div>
                            </div>
                        </template>
                        <template v-if="publicLogin && usersList.length > 0">
                            <div class="card-body">
                                <div class="table-scroll-container">
                                    <table id="myTable" class="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in usersList" :key="index">
                                                <template>
                                                    <td>{{ item.name }}</td>
                                                    <td>{{ item.mobileNo }}</td>
                                                    <td>{{ item.email }}</td>
                                                    <td>{{ item.remark }}</td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </section>
    </div>
    <footer class="footer-section">
        <p class="text-center">© 2024 Your Company. All rights reserved.</p>
    </footer>
</div>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import axios from 'axios';
import {
    fetchCustomer
} from 'src/utils/api';

export default {
    beforeRouteLeave(to, from, next) {
        if (to.path.startsWith('/admin')) {
            const isLoggedIn = !!localStorage.getItem('userToken'); // Replace with your actual login check logic
            if (!isLoggedIn) {
                next('/');
            } else {
                next();
            }
        } else {
            next();
        }
    },
    components: {
        Card
    },
    data() {
        return {
            flagReady: false,
            // tableColumns: ['Name', 'Company', 'Contact No', 'Email', 'Status', 'Address', 'Remark'],
            tableColumns: ['Name', 'Contact No', 'Email', 'Remark'],
            usersList: [],
            publicLogin: false,
            
        };
    },
    methods: {
        gotoLogin(){
            this.$router.push('/publiclogin');
        },
        authenticateUser(token){
            let apiUrl = `${process.env.VUE_APP_BASE_URL}/api.php?action=authenticate&type=public`;
            axios.post(apiUrl, {
                    token: token,
                })
                .then(response => {
                    if (response.data.status === 'success') {
                        this.publicLogin = true
                        this.loadCustomer();
                    } else {
                        sessionStorage.removeItem('publicToken')
                        sessionStorage.removeItem('publicName')
                        // alert(response.data.message);
                        console.error(response.data.message);
                        this.publicLogin = false
                    }
                })
                .catch(error => {
                    alert('Network Error: ' + error);
                });
        },
        async loadCustomer() {
            let self = this
            this.usersList = []
            try {
                const data = await fetchCustomer();
                this.usersList = data;
                console.log(this.usersList)
                if (this.usersList.length > 10) {
                    console.log('more than 10')
                    setTimeout(() => {
                        self.$nextTick(() => {
                            $('#myTable').DataTable({
                                pageLength: 10, // Default number of rows to display
                                lengthMenu: [10, 25, 50, 100], // Options for number of rows per page
                                language: {
                                    lengthMenu: "Show _MENU_ entries" // Customize the text for the page length menu
                                }
                            });
                        });
                    }, 200);
                    
                    self.$forceUpdate();
                }

            } catch (error) {
                console.error(error.message);
            }
        }
    },
    mounted() {
        if(sessionStorage.getItem('publicToken') && sessionStorage.getItem('publicName') ){
            this.authenticateUser(sessionStorage.getItem('publicToken'))
        }
        // this.loadCustomer();
    }
};
</script>

<style scoped>
/* Header Section */
.header-section {
    text-align: center;
    padding: 2rem;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url('../../assets/img/pic2.jpg') no-repeat center center;
    background-size: cover;
    color: #fff;
}

.header-section h1 {
    font-size: 2.5rem;
    margin: 0;
}

.header-section p {
    font-size: 1.25rem;
    margin-top: 0.5rem;
}

.header-img {
    max-width: 100%;
    height: auto;
    margin-top: 1rem;
}

/* Main Content */
.main-content {
    padding: 2rem;
}

.table-section {
    background: #fff;
    padding: 2rem;
    border-radius: 0.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table-section h2 {
    color: #007bff;
    margin-bottom: 1rem;
}

.table-scroll-container {
    overflow-x: auto;
}

.table {
    width: 100%;
    border-collapse: collapse;
    font-size: 1rem;
}

.table thead {
    background-color: #007bff;
}

.table > thead > tr > th{
    color: #fff;
    font-weight: bold;
    font-size: 0.6rem;
}

.table th,
.table td {
    padding: 0.75rem;
    text-align: left;
}

.table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
}

.table tbody tr:hover {
    background-color: #e9ecef;
}

/* Sections */
.news-section,
.stories-section {
    margin-top: 3rem;
}

.section-img {
    width: 100%;
    height: auto;
    margin-top: 1rem;
}

/* Footer Section */
.footer-section {
    text-align: center;
    padding: 1rem;
    background-color: #007bff;
    color: #fff;
}

.footer-section p {
    margin: 0;
}

/* Card Component */
.card {
    margin-bottom: 2rem;
    border: 1px solid #ddd;
    border-radius: 0.5rem;
}

.card img {
    max-height: 200px;
    object-fit: cover;
}

.card-body {
    padding: 1rem;
}

/* Media Query for Larger Screens */
@media (min-width: 768px) {
    .header-img {
        max-width: 50%; /* Max width 50% for screens larger than 768px */
    }
    .section-img{
        max-width: 45%;
    }
}

</style>
